<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'

const languageStore = useLanguageStore()
const route = useRoute()

const showLanguageDropdown = ref(false)
</script>

<template>
  <nav class="lang-switch d-flex justify-space-between align-center py-1" data-cy="language_switcher">
    <v-menu v-model="showLanguageDropdown" :open-on-click="false">
      <template #activator="{ props }">
        <skr-button variant="text" color="primary" v-bind="props" @click="showLanguageDropdown = !showLanguageDropdown">
          <template v-if="languageStore.locale === 'de-ch'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/DE.svg" alt="" />
            Deutsch
          </template>
          <template v-else-if="languageStore.locale === 'en-gb'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/GB.svg" alt="" />
            English
          </template>
          <template v-else-if="languageStore.locale === 'fr-ch'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/FR.svg" alt="" />
            Français
          </template>
          <template v-else-if="languageStore.locale === 'it'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/IT.svg" alt="" />
            Italiano
          </template>
          <v-icon class="ml-1">custom:expand_more</v-icon>
        </skr-button>
      </template>
      <v-list>
        <v-list-item
          v-for="locale in languageStore.selectableLocales"
          :key="locale"
          :class="['lang-switch__link', { 'is-active': languageStore.locale === locale }]"
          :to="{ path: route.fullPath, query: { ...route.query, lang: locale.split('-')[0] } }"
          :ripple="false"
          exact
        >
          <template v-if="locale === 'de-ch'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/DE.svg" alt="" data-cy="german_selector" />
            Deutsch
          </template>
          <template v-else-if="locale === 'en-gb'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/GB.svg" alt="" data-cy="english_selector" />
            English
          </template>
          <template v-else-if="locale === 'fr-ch'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/FR.svg" alt="" data-cy="french_selector" />
            Français
          </template>
          <template v-else-if="locale === 'it'">
            <nuxt-img class="mr-4" width="20" height="20" src="/img/flags/IT.svg" alt="" data-cy="italian_selector" />
            Italiano
          </template>
        </v-list-item>
      </v-list>
    </v-menu>
  </nav>
</template>

<style lang="scss" scoped>
.lang-switch {
  @include min-width {
    height: $sitefooter-height;
  }
  @include max-width {
    justify-content: flex-start;
    width: 100%;
    height: 56px;
    padding: 0;
    border-top: 1px solid $c-border;
    border-bottom: 1px solid $c-border;
  }

  .v-icon {
    margin-top: 2px;
  }

  .v-btn {
    font-size: 1rem;
    &.text-primary {
      color: $c-text !important;
    }
    &:before {
      background: $c-primary;
    }
  }

  &__link {
    @include apply-default-link-styling;
    @include max-width;

    :deep(.v-list-item__content) {
      display: flex;
      align-items: center;
    }
    &.is-active {
      font-weight: bold;
      color: $c-text-alt;
      cursor: default;
      &::before {
        opacity: 0; // Counteract Vuetify default styling
      }
    }
  }
}
</style>
